module.exports = __webpack_public_path__ + "static/img/logo4.ab67fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skin/images/logo4.png
// module id = PwS2
// module chunks = 20